<ion-app>
  <ion-split-pane [when]="showMenu ? 'lg' : false" contentId="main">
    <ion-menu *ngIf="showMenu" contentId="main" menuId="first" swipeGesture="false">
      <!-- ... il tuo contenuto menu ... -->
    </ion-menu>

    <!-- Unico router outlet, sempre presente -->
    <ion-router-outlet id="main" [swipeGesture]="false"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
